(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["antiiva-basic-offer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (!button) return;
    const wrapper = button.closest('.antiiva-offer__quantity');
    const input = wrapper && wrapper.querySelector('input[name="quantity"]');
    if (!input) return;
    const current = Number.parseInt(input.value, 10) || 1;
    input.value = button.hasAttribute('data-quantity-plus') ? current + 1 : Math.max(1, current - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antiiva-master-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const offerImage = event.target.closest('[data-master-offer-image]');
    if (offerImage) {
      const cardButton = offerImage.closest('[data-master-offer-card]').querySelector('[data-master-offer]');
      if (cardButton) cardButton.click();
      return;
    }

    const offerButton = event.target.closest('[data-master-offer]');
    if (offerButton) {
      const section = offerButton.closest('.antiiva-master');
      const form = section && section.querySelector('.antiiva-master__form');
      const variantField = form && form.querySelector('[name="id"]');
      if (!section || !form || !variantField) return;

      variantField.value = offerButton.dataset.variantId;
      variantField.dispatchEvent(new Event('change', { bubbles: true }));
      const price = section.querySelector('.antiiva-master__price');
      if (price) price.textContent = offerButton.dataset.price;

      section.querySelectorAll('[data-master-offer-card]').forEach(function(card) {
        card.classList.remove('antiiva-master__offer--selected');
      });
      section.querySelectorAll('[data-master-offer]').forEach(function(button) {
        button.classList.remove('is-current');
        const label = button.querySelector('[data-master-offer-label]');
        if (label) label.textContent = button.dataset.selectText;
      });
      const selectedCard = offerButton.closest('[data-master-offer-card]');
      selectedCard.classList.add('antiiva-master__offer--selected');
      const currentBadge = section.querySelector('[data-master-current-badge]');
      if (currentBadge) selectedCard.prepend(currentBadge);
      offerButton.classList.add('is-current');
      const selectedLabel = offerButton.querySelector('[data-master-offer-label]');
      if (selectedLabel) selectedLabel.textContent = '✓ ' + offerButton.dataset.currentText;

      const addButton = form.querySelector('[name="add"]');
      if (addButton) addButton.disabled = offerButton.dataset.available !== 'true';
      return;
    }

    const button = event.target.closest('[data-master-minus], [data-master-plus]');
    if (!button) return;
    const wrapper = button.closest('.antiiva-master__quantity');
    const input = wrapper && wrapper.querySelector('input[name="quantity"]');
    if (!input) return;
    const quantity = Number.parseInt(input.value, 10) || 1;
    input.value = button.hasAttribute('data-master-plus') ? quantity + 1 : Math.max(1, quantity - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gluco800-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const offerImage = event.target.closest('[data-master-offer-image]');
    if (offerImage) {
      const cardButton = offerImage.closest('[data-master-offer-card]').querySelector('[data-master-offer]');
      if (cardButton) cardButton.click();
      return;
    }

    const offerButton = event.target.closest('[data-master-offer]');
    if (offerButton) {
      const section = offerButton.closest('.antiiva-master');
      const form = section && section.querySelector('.antiiva-master__form');
      const variantField = form && form.querySelector('[name="id"]');
      if (!section || !form || !variantField) return;

      variantField.value = offerButton.dataset.variantId;
      variantField.dispatchEvent(new Event('change', { bubbles: true }));
      const price = section.querySelector('.antiiva-master__price');
      if (price) price.textContent = offerButton.dataset.price;

      section.querySelectorAll('[data-master-offer-card]').forEach(function(card) {
        card.classList.remove('antiiva-master__offer--selected');
      });
      section.querySelectorAll('[data-master-offer]').forEach(function(button) {
        button.classList.remove('is-current');
        const label = button.querySelector('[data-master-offer-label]');
        if (label) label.textContent = button.dataset.selectText;
      });
      const selectedCard = offerButton.closest('[data-master-offer-card]');
      selectedCard.classList.add('antiiva-master__offer--selected');
      const currentBadge = section.querySelector('[data-master-current-badge]');
      if (currentBadge) selectedCard.prepend(currentBadge);
      offerButton.classList.add('is-current');
      const selectedLabel = offerButton.querySelector('[data-master-offer-label]');
      if (selectedLabel) selectedLabel.textContent = '✓ ' + offerButton.dataset.currentText;

      const addButton = form.querySelector('[name="add"]');
      if (addButton) addButton.disabled = offerButton.dataset.available !== 'true';
      return;
    }

    const button = event.target.closest('[data-master-minus], [data-master-plus]');
    if (!button) return;
    const wrapper = button.closest('.antiiva-master__quantity');
    const input = wrapper && wrapper.querySelector('input[name="quantity"]');
    if (!input) return;
    const quantity = Number.parseInt(input.value, 10) || 1;
    input.value = button.hasAttribute('data-master-plus') ? quantity + 1 : Math.max(1, quantity - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hampstead-botanical-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hampstead-botanical-hero')) {
    customElements.define('hampstead-botanical-hero', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('.hb-hero__video');
        this.button = this.querySelector('.hb-hero__control');
        if (!this.video || !this.button || this.abortController) return;
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.poster = this.querySelector('.hb-hero__poster');
        this.posterReady = !this.poster || this.poster.complete;
        this.inViewport = false;
        this.userPaused = false;
        this.explicitPlayback = false;
        this.failed = false;
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.connection = navigator.connection;
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.button.hidden = false;
        this.updateButton();

        const posterReady = () => {
          this.posterReady = true;
          this.syncPlayback();
        };
        this.poster?.addEventListener('load', posterReady, options);
        this.poster?.addEventListener('error', posterReady, options);
        this.video.addEventListener('playing', () => {
          this.classList.add('has-video');
          this.updateButton();
        }, options);
        this.video.addEventListener('pause', () => this.updateButton(), options);
        this.video.addEventListener('error', () => {
          this.failed = true;
          this.classList.remove('has-video');
          this.button.hidden = true;
        }, options);
        this.button.addEventListener('click', () => {
          if (!this.video.paused) {
            this.userPaused = true;
            this.video.pause();
          } else {
            this.userPaused = false;
            this.explicitPlayback = true;
            this.syncPlayback();
          }
        }, options);
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        const preferenceChanged = () => {
          this.explicitPlayback = false;
          this.syncPlayback();
        };
        this.motionPreference.addEventListener('change', preferenceChanged, options);
        this.connection?.addEventListener('change', preferenceChanged, options);
        this.observer = new IntersectionObserver(entries => {
          this.inViewport = entries[0].isIntersecting;
          this.syncPlayback();
        }, { threshold: 0.01 });
        this.observer.observe(this);
      }

      syncPlayback() {
        if (!this.video || this.failed) return;
        const permitted = this.explicitPlayback || (!this.motionPreference.matches && !this.connection?.saveData);
        const shouldPlay = permitted && this.posterReady && this.inViewport && !document.hidden && !this.userPaused;
        if (!shouldPlay) {
          this.video.pause();
          return;
        }
        if (!this.video.hasAttribute('src')) {
          this.video.src = this.video.dataset.videoUrl;
          this.video.load();
        }
        if (this.video.paused) {
          this.video.play().catch(() => this.updateButton());
        }
      }

      updateButton() {
        const playing = !this.video.paused;
        const label = playing ? this.dataset.pauseLabel : this.dataset.playLabel;
        this.dataset.motionState = playing ? 'playing' : 'paused';
        this.button.setAttribute('aria-label', label);
        this.button.querySelector('.hb-hero__control-label').textContent = label;
      }

      disconnectedCallback() {
        this.video?.pause();
        this.abortController?.abort();
        this.observer?.disconnect();
        this.abortController = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hampstead-editorial-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hampstead-editorial-home')) {
    customElements.define('hampstead-editorial-home', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.cards = Array.from(this.querySelectorAll('[data-heh-card]')).sort((first, second) => Number(first.dataset.sequence) - Number(second.dataset.sequence));
        this.filters = Array.from(this.querySelectorAll('[data-heh-filter]'));
        this.goalNavigation = this.querySelector('[data-heh-goal-navigation]');
        this.browser = this.querySelector('[data-heh-browser]');
        this.productNavigation = this.querySelector('[data-heh-product-navigation]');
        this.grid = this.querySelector('[data-heh-grid]');
        this.feedback = this.querySelector('[data-heh-feedback]');
        this.status = this.querySelector('[data-heh-status]');
        this.empty = this.querySelector('[data-heh-empty]');
        this.startIndex = 0;
        this.hasNavigated = false;
        this.visibleCards = [];
        this.visibleCount = 0;
        const options = { signal: this.controller.signal };

        this.addEventListener('click', (event) => {
          const arrow = event.target.closest('[data-heh-product-step]');
          if (arrow && this.contains(arrow)) {
            this.stepProduct(arrow.dataset.hehProductStep);
            return;
          }
          const filter = event.target.closest('[data-heh-filter]');
          if (filter && this.contains(filter)) {
            this.setCategory(filter.dataset.hehFilter);
            return;
          }
          if (event.target.closest('[data-heh-reset]')) {
            const activeFilter = this.filters.find((item) => item.dataset.hehFilter === this.activeCategory);
            this.setCategory('');
            activeFilter?.focus({ preventScroll: true });
          }
        }, options);

        this.addEventListener('shopify:block:select', (event) => {
          const card = this.cards.find((item) => item.dataset.blockId === event.detail?.blockId);
          if (card) this.showCard(card, false);
        }, options);

        this.updateProducts(false);
        if (this.goalNavigation && this.cards.length) this.goalNavigation.hidden = false;

        const updatePosition = () => this.scheduleControlPosition();
        window.addEventListener('resize', () => {
          if (Math.min(this.cards.length, this.getWindowSize()) !== this.visibleCount) this.updateProducts(false);
          else this.scheduleControlPosition();
        }, options);
        if (this.browser && 'ResizeObserver' in window) {
          this.controlsObserver = new ResizeObserver(updatePosition);
          this.controlsObserver.observe(this.browser);
        }
        this.scheduleControlPosition();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.controlsObserver?.disconnect();
        this.controlsObserver = null;
        if (this.positionFrame) cancelAnimationFrame(this.positionFrame);
        this.positionFrame = null;
      }

      getWindowSize() {
        if (window.matchMedia('(min-width: 900px)').matches) return 3;
        return window.matchMedia('(min-width: 600px)').matches ? 2 : 1;
      }

      scheduleControlPosition() {
        if (this.positionFrame) return;
        this.positionFrame = requestAnimationFrame(() => {
          this.positionFrame = null;
          if (!this.isConnected || !this.browser) return;
          const image = this.visibleCards[0]?.querySelector('.heh__card-image-link');
          if (!image) return;
          const imageBounds = image.getBoundingClientRect();
          const browserBounds = this.browser.getBoundingClientRect();
          const position = imageBounds.top - browserBounds.top + imageBounds.height / 2;
          this.browser.style.setProperty('--heh-product-control-y', `${Math.round(position)}px`);
        });
      }

      stepProduct(direction) {
        if (!this.cards.length) return;
        this.startIndex = (this.startIndex + (direction === 'previous' ? -1 : 1) + this.cards.length) % this.cards.length;
        this.hasNavigated = true;
        this.updateProducts(true);
      }

      showCard(card, announce = true) {
        const index = this.cards.indexOf(card);
        if (index < 0) return;
        this.startIndex = index;
        this.hasNavigated = true;
        this.updateProducts(announce);
      }

      setCategory(category, announce = true) {
        if (category) {
          const card = this.cards.find((item) => item.dataset.category === category);
          if (card) this.showCard(card, announce);
          return;
        }
        this.startIndex = 0;
        this.hasNavigated = false;
        this.updateProducts(announce);
      }

      updateProducts(announce) {
        const orderedCards = this.cards.slice(this.startIndex).concat(this.cards.slice(0, this.startIndex));
        const focusedElement = document.activeElement;
        const focusedCard = this.cards.find((card) => card.contains(focusedElement));
        this.visibleCount = Math.min(this.cards.length, this.getWindowSize());
        this.visibleCards = orderedCards.slice(0, this.visibleCount);
        this.activeCategory = this.visibleCards[0]?.dataset.category || '';

        orderedCards.forEach((card, index) => {
          card.hidden = index >= this.visibleCount;
          if (this.grid && this.grid.children[index] !== card) this.grid.insertBefore(card, this.grid.children[index] || null);
        });
        for (const filter of this.filters) {
          filter.setAttribute('aria-pressed', String(Boolean(this.activeCategory) && filter.dataset.hehFilter === this.activeCategory));
        }
        const hasNavigation = this.cards.length > this.visibleCount;
        if (this.productNavigation) this.productNavigation.hidden = !hasNavigation;
        if (this.browser) this.browser.dataset.enhanced = String(hasNavigation);
        if (this.grid) this.grid.dataset.visibleCount = String(this.visibleCount);
        if (this.feedback) this.feedback.hidden = !this.hasNavigated;
        if (this.empty) this.empty.hidden = this.visibleCount > 0;
        if (announce && this.status) {
          const titles = this.visibleCards.map((card) => card.querySelector('.heh__card-title')?.textContent.trim() || '').filter(Boolean);
          this.status.textContent = (this.dataset.windowStatus || '').replace('[products]', titles.join(', '));
        }
        if (focusedCard) {
          const focusTarget = focusedCard.hidden ? this.visibleCards[0]?.querySelector('.heh__card-title a') : focusedElement;
          if (focusTarget && document.activeElement !== focusTarget) focusTarget.focus({ preventScroll: true });
        }
        this.scheduleControlPosition();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mens-health-pack-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const offerImage = event.target.closest('[data-master-offer-image]');
    if (offerImage) {
      const cardButton = offerImage.closest('[data-master-offer-card]').querySelector('[data-master-offer]');
      if (cardButton) cardButton.click();
      return;
    }

    const offerButton = event.target.closest('[data-master-offer]');
    if (offerButton) {
      const section = offerButton.closest('.antiiva-master');
      const form = section && section.querySelector('.antiiva-master__form');
      const variantField = form && form.querySelector('[name="id"]');
      if (!section || !form || !variantField) return;

      variantField.value = offerButton.dataset.variantId;
      variantField.dispatchEvent(new Event('change', { bubbles: true }));
      const price = section.querySelector('.antiiva-master__price');
      if (price) price.textContent = offerButton.dataset.price;

      section.querySelectorAll('[data-master-offer-card]').forEach(function(card) {
        card.classList.remove('antiiva-master__offer--selected');
      });
      section.querySelectorAll('[data-master-offer]').forEach(function(button) {
        button.classList.remove('is-current');
        const label = button.querySelector('[data-master-offer-label]');
        if (label) label.textContent = button.dataset.selectText;
      });
      const selectedCard = offerButton.closest('[data-master-offer-card]');
      selectedCard.classList.add('antiiva-master__offer--selected');
      const currentBadge = section.querySelector('[data-master-current-badge]');
      if (currentBadge) selectedCard.prepend(currentBadge);
      offerButton.classList.add('is-current');
      const selectedLabel = offerButton.querySelector('[data-master-offer-label]');
      if (selectedLabel) selectedLabel.textContent = '✓ ' + offerButton.dataset.currentText;

      const addButton = form.querySelector('[name="add"]');
      if (addButton) addButton.disabled = offerButton.dataset.available !== 'true';
      return;
    }

    const button = event.target.closest('[data-master-minus], [data-master-plus]');
    if (!button) return;
    const wrapper = button.closest('.antiiva-master__quantity');
    const input = wrapper && wrapper.querySelector('input[name="quantity"]');
    if (!input) return;
    const quantity = Number.parseInt(input.value, 10) || 1;
    input.value = button.hasAttribute('data-master-plus') ? quantity + 1 : Math.max(1, quantity - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milk-thistle-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const offerImage = event.target.closest('[data-master-offer-image]');
    if (offerImage) {
      const cardButton = offerImage.closest('[data-master-offer-card]').querySelector('[data-master-offer]');
      if (cardButton) cardButton.click();
      return;
    }

    const offerButton = event.target.closest('[data-master-offer]');
    if (offerButton) {
      const section = offerButton.closest('.antiiva-master');
      const form = section && section.querySelector('.antiiva-master__form');
      const variantField = form && form.querySelector('[name="id"]');
      if (!section || !form || !variantField) return;

      variantField.value = offerButton.dataset.variantId;
      variantField.dispatchEvent(new Event('change', { bubbles: true }));
      const price = section.querySelector('.antiiva-master__price');
      if (price) price.textContent = offerButton.dataset.price;

      section.querySelectorAll('[data-master-offer-card]').forEach(function(card) {
        card.classList.remove('antiiva-master__offer--selected');
      });
      section.querySelectorAll('[data-master-offer]').forEach(function(button) {
        button.classList.remove('is-current');
        const label = button.querySelector('[data-master-offer-label]');
        if (label) label.textContent = button.dataset.selectText;
      });
      const selectedCard = offerButton.closest('[data-master-offer-card]');
      selectedCard.classList.add('antiiva-master__offer--selected');
      const currentBadge = section.querySelector('[data-master-current-badge]');
      if (currentBadge) selectedCard.prepend(currentBadge);
      offerButton.classList.add('is-current');
      const selectedLabel = offerButton.querySelector('[data-master-offer-label]');
      if (selectedLabel) selectedLabel.textContent = '✓ ' + offerButton.dataset.currentText;

      const addButton = form.querySelector('[name="add"]');
      if (addButton) addButton.disabled = offerButton.dataset.available !== 'true';
      return;
    }

    const button = event.target.closest('[data-master-minus], [data-master-plus]');
    if (!button) return;
    const wrapper = button.closest('.antiiva-master__quantity');
    const input = wrapper && wrapper.querySelector('input[name="quantity"]');
    if (!input) return;
    const quantity = Number.parseInt(input.value, 10) || 1;
    input.value = button.hasAttribute('data-master-plus') ? quantity + 1 : Math.max(1, quantity - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ultra-nerve-support-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const offerImage = event.target.closest('[data-master-offer-image]');
    if (offerImage) {
      const cardButton = offerImage.closest('[data-master-offer-card]').querySelector('[data-master-offer]');
      if (cardButton) cardButton.click();
      return;
    }

    const offerButton = event.target.closest('[data-master-offer]');
    if (offerButton) {
      const section = offerButton.closest('.antiiva-master');
      const form = section && section.querySelector('.antiiva-master__form');
      const variantField = form && form.querySelector('[name="id"]');
      if (!section || !form || !variantField) return;

      variantField.value = offerButton.dataset.variantId;
      variantField.dispatchEvent(new Event('change', { bubbles: true }));
      const price = section.querySelector('.antiiva-master__price');
      if (price) price.textContent = offerButton.dataset.price;

      section.querySelectorAll('[data-master-offer-card]').forEach(function(card) {
        card.classList.remove('antiiva-master__offer--selected');
      });
      section.querySelectorAll('[data-master-offer]').forEach(function(button) {
        button.classList.remove('is-current');
        const label = button.querySelector('[data-master-offer-label]');
        if (label) label.textContent = button.dataset.selectText;
      });
      const selectedCard = offerButton.closest('[data-master-offer-card]');
      selectedCard.classList.add('antiiva-master__offer--selected');
      const currentBadge = section.querySelector('[data-master-current-badge]');
      if (currentBadge) selectedCard.prepend(currentBadge);
      offerButton.classList.add('is-current');
      const selectedLabel = offerButton.querySelector('[data-master-offer-label]');
      if (selectedLabel) selectedLabel.textContent = '✓ ' + offerButton.dataset.currentText;

      const addButton = form.querySelector('[name="add"]');
      if (addButton) addButton.disabled = offerButton.dataset.available !== 'true';
      return;
    }

    const button = event.target.closest('[data-master-minus], [data-master-plus]');
    if (!button) return;
    const wrapper = button.closest('.antiiva-master__quantity');
    const input = wrapper && wrapper.querySelector('input[name="quantity"]');
    if (!input) return;
    const quantity = Number.parseInt(input.value, 10) || 1;
    input.value = button.hasAttribute('data-master-plus') ? quantity + 1 : Math.max(1, quantity - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vitamin-d3-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const offerImage = event.target.closest('[data-master-offer-image]');
    if (offerImage) {
      const cardButton = offerImage.closest('[data-master-offer-card]').querySelector('[data-master-offer]');
      if (cardButton) cardButton.click();
      return;
    }

    const offerButton = event.target.closest('[data-master-offer]');
    if (offerButton) {
      const section = offerButton.closest('.antiiva-master');
      const form = section && section.querySelector('.antiiva-master__form');
      const variantField = form && form.querySelector('[name="id"]');
      if (!section || !form || !variantField) return;

      variantField.value = offerButton.dataset.variantId;
      variantField.dispatchEvent(new Event('change', { bubbles: true }));
      const price = section.querySelector('.antiiva-master__price');
      if (price) price.textContent = offerButton.dataset.price;

      section.querySelectorAll('[data-master-offer-card]').forEach(function(card) {
        card.classList.remove('antiiva-master__offer--selected');
      });
      section.querySelectorAll('[data-master-offer]').forEach(function(button) {
        button.classList.remove('is-current');
        const label = button.querySelector('[data-master-offer-label]');
        if (label) label.textContent = button.dataset.selectText;
      });
      const selectedCard = offerButton.closest('[data-master-offer-card]');
      selectedCard.classList.add('antiiva-master__offer--selected');
      const currentBadge = section.querySelector('[data-master-current-badge]');
      if (currentBadge) selectedCard.prepend(currentBadge);
      offerButton.classList.add('is-current');
      const selectedLabel = offerButton.querySelector('[data-master-offer-label]');
      if (selectedLabel) selectedLabel.textContent = '✓ ' + offerButton.dataset.currentText;

      const addButton = form.querySelector('[name="add"]');
      if (addButton) addButton.disabled = offerButton.dataset.available !== 'true';
      return;
    }

    const button = event.target.closest('[data-master-minus], [data-master-plus]');
    if (!button) return;
    const wrapper = button.closest('.antiiva-master__quantity');
    const input = wrapper && wrapper.querySelector('input[name="quantity"]');
    if (!input) return;
    const quantity = Number.parseInt(input.value, 10) || 1;
    input.value = button.hasAttribute('data-master-plus') ? quantity + 1 : Math.max(1, quantity - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  } catch(e) { console.error(e); }
})();
})();
